export const promptVars = {
    name: '%name%',
    intent: '%intent%',
    type: '%type%',
    specification: '%specification%',
    roles: '%roles%',
    roleNames: '%roleNames%',
    roleName: '%roleName%',
    entities: '%entities%',
    /** @see printModel */
    model: '%model%',
    /** @see printModelStmts */
    modelStmts: '%modelStmts%',
    /** all dsl statements */
    modelDsl: '%modelDsl%',
    userInput: '%userInput%',
    /** @see printStructure */
    structure: '%structure%',
    /** @see printCrudStructureStmts */
    structureCrudStmts: '%structureCrudStmts%',
    structureDsl: '%structureDsl%',
    /** @see printStructureStmts */
    structureStmts: '%structureStmts%',
    /** @see printStructureNavigation */
    navigation: '%navigation%',
    navigationStmts: '%navigationStmts%',
    /** @see for fixing */
    errors: '%errors%',
    pluginsSchema: '%pluginsSchema%',
    // pluginsStructure: '%pluginsStructure%',
    editSourceFile: '%editSourceFile%',
    editSourceFileContent: '%editSourceFileContent%',
    editSourceRequestMessage: '%editSourceRequestMessage%',
};
//# sourceMappingURL=variables.js.map